"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelImageVisibility = exports.CollectionModelImageVisibilityMutator = void 0;
const imageVisibility_state_1 = require("./imageVisibility.state");
class CollectionModelImageVisibilityMutator {
    constructor(imageVisibility) {
        this.imageVisibility = imageVisibility;
    }
    setValue(state) {
        this.imageVisibility.collectionState.setFieldValue(this.imageVisibility.instanceId, state);
    }
    /** Gives a shallow clone of the image visibility state */
    getValue() {
        return Object.assign({}, this.imageVisibility.state);
    }
    /**
     * Remove the state of this image visibility
     * *Warning:* You will need to unlink & clear the image visibility before destroying the state.
     * @see CollectionModelImageVisibilityStateMutator.remove
     */
    destroyState() {
        this.imageVisibility.collectionState.setFieldValue(this.imageVisibility.instanceId, null);
    }
    /**
     * Remove the image visibility,
     * This will unlink and destroy the image visibility and all associated values.
     *
     * @see CollectionModelImageVisibilityStateMutator.remove
     */
    remove() {
        this.imageVisibility.imageVisibilityState.Mutator.clear();
    }
}
exports.CollectionModelImageVisibilityMutator = CollectionModelImageVisibilityMutator;
class CollectionModelImageVisibility {
    constructor(state, imageVisibilityId, captureId) {
        this.instanceId = imageVisibility_state_1.CollectionModelImageVisibilityState.imageVisibilityId(captureId);
        this.id = imageVisibilityId;
        this.captureId = captureId;
        this.imageVisibilityState = state;
    }
    get state() {
        return this.collectionState.getFieldValue(this.instanceId);
    }
    get collectionState() {
        return this.imageVisibilityState.collection.state;
    }
    get isDeletable() {
        return true;
    }
}
exports.CollectionModelImageVisibility = CollectionModelImageVisibility;
//# sourceMappingURL=imageVisibility.js.map